import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "AID_FLOWS_GROUPED",
  title: defineMessage({
    id: "fig.finance.aid.AID_FLOWS_GROUPED.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.AID_FLOWS_GROUPED.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.AID_FLOWS_GROUPED.source",
    defaultMessage: ``,
  }),
};
